import React from 'react';
import {useMediaQuery} from 'src/hooks/useMediaQuery';
import PortfolioSectionHeader from 'shared/portfolio/components/portfolio-section-header';

import GpaAndTips from './gpa-and-tips';
import CurrentSchoolYears from './current-school-years';
import UpcomingSchoolYears from './upcoming-school-years';
import useFeatureFlags from '../../../src/hooks/useFeatureFlags';
import PortfolioIcon from 'shared/portfolio/components/portfolio-icon/portfolio-icon';

const BulkEntry = () => {
  const mq = useMediaQuery();
  const {viewImportReportCard} = useFeatureFlags(['viewImportReportCard']);

  return (
    <div id="courses">
      <PortfolioSectionHeader
        title="Courses"
        displayNew={false}
        sectionName="bulk-entry"
        extraComponent={<GpaAndTips />}
        viewImportReportCard={viewImportReportCard}
      >
        <PortfolioIcon type="courses" size={mq.XS ? 40 : 56} />
      </PortfolioSectionHeader>
      <CurrentSchoolYears />
      <UpcomingSchoolYears />
    </div>
  );
};

export default BulkEntry;
